<template>
<div class="container p-4">
    <div class="alert alert-primary">
        <strong> Select one reference Image. This Image will be used to define
            crop parameters and manual Starting points. </strong>
    </div>
    <vue-select-image :data-images="this.form.files" w="256" @onselectimage="onSelectImage">
    </vue-select-image>
</div>
</template>

<script>
import VueSelectImage from "vue-select-image";
export default {
    props: ["form"],
    sync: ["refimage"],
    components: {
        VueSelectImage
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {
        onSelectImage(data) {
            console.log("fire event onSelectImage: ", data);
            // this.$emit('update-refimage', image.src)
            this.form.refimage = data;
            console.log(this.form.refimage);
        },
        copyObject(obj) {
            var cp = {};
            for (var o in obj) {
                cp[o] = obj[o];
            }
            return cp;
        }
    }
};
</script>
